// extracted by mini-css-extract-plugin
export default {"container":"category-collapsible__container___2KM76"};